import { defineSlotRecipe } from "@chakra-ui/react";
export const comboboxRecipe = defineSlotRecipe({
    className: "chakra-combobox",
    slots: ["root", "control", "input", "content", "item", "itemText", "itemIndicator"],
    base: {
        control: {
            rounded: "md",
            display: "flex",
            alignItems: "center",
            gap: "1",
            cursor: "pointer",
            paddingStart: "2.5",
            paddingEnd: "2",
            borderWidth: "1px",
            borderColor: "border",
            bg: "bg",
            transitionProperty: "common",
            transitionDuration: "normal",
            _hover: {
                borderColor: "border.emphasized",
            },
            _focusWithin: {
                borderColor: "border.emphasized",
                boxShadow: "none",
                outline: "none",
            },
        },
        input: {
            cursor: "pointer",
            border: "none",
            outline: "none !important",
            boxShadow: "none !important",
            bg: "transparent",
            paddingX: "0 !important",
            _focus: {
                border: "none",
                outline: "none !important",
                boxShadow: "none !important",
            },
            _focusVisible: {
                outline: "none !important",
                boxShadow: "none !important",
            },
        },
        content: {
            rounded: "md",
            borderColor: "border",
        },
        item: {
            rounded: "md",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            _hover: {
                bg: "gray.50",
            },
            _highlighted: {
                bg: "gray.50",
            },
            _selected: {
                bg: "colorPalette.subtle",
                color: "colorPalette.focusRing",
                fontWeight: "medium",
            },
        },
        itemIndicator: {
            color: "colorPalette.focusRing",
        },
    },
    variants: {
        variant: {
            outline: {
                input: {
                    bg: "transparent",
                    border: "none",
                    rounded: "md",
                    _hover: {},
                    _focus: {
                        outline: "none",
                        border: "none",
                        boxShadow: "none",
                    },
                },
            },
        },
        size: {
            xs: {
                control: { h: "8", textStyle: "xs" },
                input: { h: "full", textStyle: "xs" },
            },
            sm: {
                control: { h: "9", textStyle: "sm" },
                input: { h: "full", textStyle: "sm" },
            },
            md: {
                control: { h: "10", textStyle: "sm" },
                input: { h: "full", textStyle: "sm" },
            },
            lg: {
                control: { h: "11", textStyle: "md" },
                input: { h: "full", textStyle: "md" },
            },
        },
    },
    defaultVariants: {
        variant: "outline",
        size: "md",
    },
});
